/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\OfferFiles\OfferFiles.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Thursday October 10th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday October 10th 2024 10:26:38 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useEffect, useMemo, useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import translator from "MultiLanguage/TranslationWrapper";
import { OfferFileType } from "Types/offer.type";
import OfferFilesRow from "./OfferFilesRow";

type OfferFilesProps = {
    offerID: string,
    getter: Function
}

export default function OfferFiles(props: OfferFilesProps) {
    const [files, setFiles] = useState<OfferFileType[]>([]);
    const headers = ["File"];

    const buildRows = (files: OfferFileType[]) => {
        const offerFileToDisplay: JSX.Element[] = [];
        for (let i = 0; i < files.length; ++i)
            offerFileToDisplay.push(
                <OfferFilesRow key={`${files[i].id}_${Math.random()}`} file={files[i]}/>
            );
        return offerFileToDisplay;
    };

    const offerValues = useMemo(() => {
        return buildRows(files);
    }, [files]);

    useEffect(() => {
        props.getter().then((result: {data: OfferFileType[]}) => {
            setFiles(result.data);
        }).catch((error: any) => {
            console.error(error);
        });
    }, []);

    return (
        <>
            {files.length !== 0 ?
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            {headers.map(x => <TableCell key={`${x}_${Math.random()}`} align="center"><strong>{translator.decode(`table.headers.${x}`)}</strong></TableCell>)}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {offerValues}
                    </TableBody>
                </Table>
                :null
            }
        </>
    );
};
